import Cookies from "js-cookie";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function RouteTracker() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.log("Route changed to: ", location.pathname);
    navigateByAuthCookie(location.pathname);
  }, [location]);

  const navigateByAuthCookie = (currPath: string) => {
    const XAT = Cookies.get("X-AUTH-TOKEN");
    const isAuth = Boolean(XAT);
    const isLoginPage = Boolean(currPath === "/login");

    const noAuthPaths = ["/login", "/sign-up"];
    if (isAuth) {
      if (noAuthPaths.includes(currPath)) navigate("/bank");
      else if (currPath === "/") navigate("/bank");
    } else {
      if (!isLoginPage && !noAuthPaths.includes(currPath)) {
        navigate("/login");
      }
    }
  };

  return null;
}

export default RouteTracker;
